/* AHVA quick add on product cards: small size chips next to the "+" on the photo (hover or "+" on computers, "+" on phones).
   One tap on a size adds it to the cart, flashes "Added ✓" and opens the theme's cart drawer. */
(function () {
  if (window.customElements.get('ahva-quick-add')) return;

  var closeAll = function (except) {
    document.querySelectorAll('ahva-quick-add.is-open').forEach(function (el) { if (el !== except) el.close(); });
  };

  class AhvaQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.toggle = this.querySelector('.ahva-qa__toggle');
      this.msg = this.querySelector('.ahva-qa__msg');
      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.classList.contains('is-open')) this.close(); else this.open();
      });
      this.querySelectorAll('.ahva-qa__size').forEach((b) => {
        b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.add(b); });
      });
    }

    open() {
      closeAll(this);
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    add(btn) {
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      var label = btn.textContent;
      this.msg.textContent = '';
      btn.setAttribute('aria-busy', 'true');
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then((res) => {
          btn.removeAttribute('aria-busy');
          if (!res.ok) {
            this.msg.textContent = res.j.description || 'Sorry, that size couldn’t be added. Please try again.';
            return;
          }
          btn.classList.add('is-added');
          btn.textContent = 'Added ✓';
          setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = label; this.close(); }, 1600);
          // Let "Added ✓" show for a moment, then open the cart drawer
          var wait = new Promise(function (r) { setTimeout(r, 650); });
          return Promise.all([fetch(root + 'cart.js').then(function (r) { return r.json(); }), wait]).then(function (all) {
            var cart = all[0];
            cart.sections = res.j.sections || {};
            btn.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.j.items || [res.j], cart: cart, onSuccessDo: 'force_open_drawer' } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          });
        })
        .catch(() => {
          btn.removeAttribute('aria-busy');
          this.msg.textContent = 'Sorry, something went wrong. Please try again.';
        });
    }
  }

  window.customElements.define('ahva-quick-add', AhvaQuickAdd);

  // Tap anywhere else (or press Escape) to close an open strip
  document.addEventListener('click', function (e) { if (!e.target.closest('ahva-quick-add')) closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
